export default {
  data() {
    return {
      imagelist: [],
      imagelist_narrow: [{
        img: require("@/assets/maindetail/main_show_narrow_1.jpg")
      }, {
        img: require("@/assets/maindetail/main_show_narrow_2.jpg")
      }, {
        img: require("@/assets/maindetail/main_show_narrow_3.jpg")
      }, {
        img: require("@/assets/maindetail/main_show_narrow_4.jpg")
      }],
      imagelist_wide: [{
        img: require("@/assets/maindetail/main_show_wide_1.jpg")
      }, {
        img: require("@/assets/maindetail/main_show_wide_2.jpg")
      }, {
        img: require("@/assets/maindetail/main_show_wide_3.jpg")
      }, {
        img: require("@/assets/maindetail/main_show_wide_4.jpg")
      }],
      bannerHeight: 0
    };
  },
  mounted() {
    // 获得show section的组件的属性
    let show_section = document.getElementById("show_section");
    // console.log(show_section);
    this.bannerHeight = show_section.clientHeight;
    window.onresize = () => {
      this.bannerHeight = show_section.clientHeight;
      this.setimagelist();
    };
    this.setimagelist();
  },
  methods: {
    setimagelist() {
      // 根据屏幕宽高比，宽高比大于0.9的为宽屏，否则为窄屏
      if (window.innerWidth / window.innerHeight > 0.9) {
        this.imagelist = this.imagelist_wide;
      } else {
        this.imagelist = this.imagelist_narrow;
      }
    }
  }
};